import { useContext } from 'react';
import { DrawerContext } from 'src/contexts/DrawerContextProvider';

export const useDrawerState = () => useContext(DrawerContext);
